import {Divider, Image, Layout, Typography} from 'antd';
import React from 'react';
import appColors from '../../style/theme';

const {Text, Paragraph} = Typography;
const Content = Layout;
const EndUser = () => {
  return (
    <Layout style={{margin: '5.2vh', background: 'transparent'}}>
      <Content style={{background: 'inherit'}}>
        <Paragraph className= 'Title3' style={{color: appColors['ColorX'], marginTop: '-7vh'}}>End-users</Paragraph>
        <Text className='BaseText2'>We believe that there are two potential users for our product. The first is the patient who already presents chronic diseases and that could use the device to track the evolution of their condition and the impact of their treatment. Additionally, further research with our stakeholders and in literature led us to realize that age-related diseases present a long subclinical incubation period that may begin when people are in their 40s or 50s. In this period, the clinical signs are unobservable until a threshold is met and the disease is fully triggered [1]. Therefore, we decided that iMoAge could also be used by younger people between 45-65 years for an early detection of age-related diseases that strengthens prevention strategies. However, these users will only be interested in taking the test if they are aware of the consequences of an unhealthy aging trajectory. Accordingly, a health culture around aging must be fostered.</Text>
        <Content style={{marginLeft: 'auto', marginRight: 'auto', maxWidth: '80%', background: 'inherit', marginTop: '2%'}}>
          <Image src='https://static.igem.wiki/teams/4464/wiki/project-implementation/end-users.png'/>
        </Content>
      </Content>
      <Divider/>
    </Layout>
  );
};

export default EndUser;
